import getAppCustomEnv from "./get-app-custom-env";
import { loadStripe } from "@stripe/stripe-js";
import isArray from "lodash/isArray";
import first from "lodash/first";

// This is use to tracked the error of stripe elements
const error = { card: null, expiry: null, cvc: null };

let buildStripeInputClasses = () => {
  return {
    focus: "focused",
    empty: "empty",
  };
};

let buildStripeInputStyleOverrides = () => {
  return {
    base: {
      "::placeholder": {
        color: "#CFD7E0",
      },
    },
    invalid: {
      "::placeholder": {
        color: "#ff2122",
      },
    },
  };
};

let setupStripe = async (component) => {
  let appCustomEnv = await getAppCustomEnv();
  let partner = await localStorage.getItem("partner");
  let stripeConfig = "";
  console.log("test stripe start::");
  if (partner && partner != "null") {
    console.log("stripe MS start::", partner);
    stripeConfig = appCustomEnv.VUE_APP_MS_STRIPE_PUBLISHABLE_KEY;
  } else {
    console.log("stripe def start::", partner);
    stripeConfig = appCustomEnv.VUE_APP_STRIPE_PUBLISHABLE_KEY;
  }
  component.stripe = await loadStripe(stripeConfig);
  let elements = component.stripe.elements();
  let classes = buildStripeInputClasses();
  let style = buildStripeInputStyleOverrides();

  // Create an instance of the card Element
  component.card = elements.create("cardNumber", { classes, style });
  component.expiry = elements.create("cardExpiry", { classes, style });
  component.cvc = elements.create("cardCvc", { classes, style });

  // Element creation takes more time and setTimeout with 0 delay
  // helps in ensuring the existence of the Stripe elements to be
  // mounted.
  component.$nextTick(() => {
    if (isArray(component.$refs.cardNumber) && component.$refs.cardNumber.length) {
      component.card.mount(first(component.$refs.cardNumber));
    } else if (component.$refs.cardNumber) {
      component.card.mount(component.$refs.cardNumber);
    }

    if (isArray(component.$refs.cardExpiry) && component.$refs.cardExpiry.length) {
      component.expiry.mount(first(component.$refs.cardExpiry));
    } else if (component.$refs.cardExpiry) {
      component.expiry.mount(component.$refs.cardExpiry);
    }

    if (isArray(component.$refs.cardCvc) && component.$refs.cardCvc.length) {
      component.cvc.mount(first(component.$refs.cardCvc));
    } else if (component.$refs.cardCvc) {
      component.cvc.mount(component.$refs.cardCvc);
    }
    // Add an instance of the card Element into the `card-element` <div>

    // Add event listeners
    handleCardNumberErrorEvents(component);
    handleCardExpiryErrorEvents(component);
    handleCardCvcErrorEvents(component);
  });
};

let handleCardNumberErrorEvents = (component) => {
  component.card.addEventListener("change", function (event) {
    component.cardNumberBrand = event.brand;
    let displayError = component.$refs.cardNumberErrors;
    if (event.error) {
      displayError.textContent = event.error.message;
    } else {
      displayError.textContent = null;
    }
    error.card = displayError.textContent;
    checkValid(component);
  });
};

let handleCardExpiryErrorEvents = (component) => {
  component.expiry.addEventListener("change", function (event) {
    let displayError = component.$refs.cardExpiryErrors;
    if (event.error) {
      displayError.textContent = event.error.message;
    } else {
      displayError.textContent = null;
    }
    error.expiry = displayError.textContent;

    checkValid(component);
  });
};

let handleCardCvcErrorEvents = (component) => {
  component.cvc.addEventListener("change", function (event) {
    let displayError = component.$refs.cardCvcErrors;
    if (event.error) {
      displayError.textContent = event.error.message;
    } else {
      displayError.textContent = null;
    }
    error.cvc = displayError.textContent;

    checkValid(component);
  });
};

const checkValid = (component) => {
  if (error.card || error.cvc || error.expiry) {
    console.log("invalid");
    component.invalidCard = true;
  } else {
    console.log("valid");
    component.invalidCard = false;
  }
};

export { setupStripe };
